import TransactionNotarialBookCard from "./transaction_notarial_book_card";
import TransactionNotarialBookTable from "./transaction_notarial_book_table";

const TabTransactions = () => {
    return (
    <>
        <TransactionNotarialBookCard/>
        <TransactionNotarialBookTable/>
    </> );
}
 
export default TabTransactions;